import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import { injectIntl, FormattedMessage } from 'react-intl';
import propTypes from 'prop-types';
import '../../common/dropDown/dropDown.scss';
import { changeLanguage } from '../../../actions/language';
import { getValue } from '../../../utils/utility/booking';
import { Checkbox, Button } from '../../../component';
import { ChevronDownIcon, ChevronUpIcon } from '~svg';

class MultiSelectDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenOption: false,
      selected: props.value || [],
      search: '',
      suggestion: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && typeof nextProps.value === 'object') {
      this.setState({ selected: nextProps.value });
    } else if (nextProps && nextProps.value !== 'object') {
      if (!nextProps.value) {
        this.setState({ selected: [] });
      } else {
        this.findSendValueInDataOfDropDown(nextProps.value);
      }
    }
  }

  componentDidMount() {
    this.findSendValueInDataOfDropDown(this.props.value);
    document.addEventListener('mousedown', this.handleclick, false);
  }

  componentDidUpdate(prevProps) {
    // when reset data , checkboxs off
    const { value } = this.props;
    if (value !== prevProps.value)
      this.setState({
        selected: value,
      });
  }

  findSendValueInDataOfDropDown = (newValue) => {
    newValue = newValue.filter((x) => Object.keys(x).length);
    let { data, send, hasChild } = this.props;
    let selected = {};
    if (hasChild)
      selected = data.filter((item) => getValue(item, hasChild) === newValue);
    else {
      if (newValue.constructor === Array) {
        selected = data.filter((item) => newValue.includes(item[send]));
      } else selected = data.filter((item) => item[send] === newValue);
    }
    if (selected.length > 0) {
      this.setState({ selected });
    }
  };

  onChangeInput = (event) => {
    let suggestion = '';
    let { value } = event.target;
    let { show, data, hasChild, language } = this.props;

    if (value.length) {
      let tmp = data.filter((item) => {
        if (typeof item === 'object') {
          if (hasChild) {
            return getValue(item, hasChild);
          } else if (item?.[show]?.[language.name]) return;
          item?.[show]?.[language?.name].indexOf(value) === 0 || '';
        } else return item ? item.indexOf(value) === 0 : '';
      });
      if (tmp.length) {
        if (hasChild) {
          let lodash = getValue(tmp[0], hasChild);
          suggestion =
            lodash.constructor === Array
              ? lodash?.[0]?.[show]?.[language?.name || 'en']
              : lodash?.[show];
        } else if (typeof tmp[0] === 'object')
          suggestion = tmp?.[0]?.[show]?.[language?.name || 'en'];
        else suggestion = tmp[0];
      }
    }
    this.setState({
      search: value,
      suggestion,
    });
  };
  //ُShow Checkbox label in checkbox list
  renderListOptionShow = (item) => {
    let { show, language, hasChild } = this.props;
    if (item?.constructor === Array)
      return item?.[0]?.[show]?.[language.name || 'en'];
    else if (item?.[show]?.constructor === Array)
      return item?.[show][0]?.[hasChild]?.[language.name || 'en'];
    else if (item.constructor === Object) {
      if (item[show]) return item?.[show]?.[language.name || 'en'];
    } else if (item.constructor === String) return item?.[show] || item;
  };
  //select all airlines
  selectAll = (event, searchData) => {
    let { checked } = event.target;
    if (checked)
      this.setState(
        {
          selected: searchData,
        },
        () =>
          this.props.onClick({
            stateName: this.props.id,
            value: this.state.selected,
          }),
      );
    else {
      this.setState(
        {
          selected: [],
        },
        () =>
          this.props.onClick({
            stateName: this.props.id,
            value: this.state.selected,
          }),
      );
    }
  };
  // get checked of every checkbox
  onChange = (event) => {
    const { data } = this.props;
    let { checked, name, id } = event.target,
      { selected } = this.state,
      index = selected.findIndex((item) =>
        isNaN(item.id) ? item.id === id : item.id === parseInt(id),
      );

    if (checked && index === -1) {
      selected.push(data.find((x) => x.id === parseInt(name)));
    } else {
      if (index > -1) {
        selected.splice(index, 1);
      }
    }
    selected = selected?.filter((x) => Object.keys(x)?.length);
    this.setState({ selected }, () => {
      this.props.onClick({
        stateName: this.props.id,
        value: this.state.selected,
      });
    });
  };

  //render options of dropdown
  renderListOption = (search) => {
    let { show, id, send, theme } = this.props;
    if (search[0] && search[0].constructor === Array) search = search.flat();
    return search.map((item, index) => {
      if (item && getValue(item, show) !== null) {
        return (
          <div key={index}>
            <Checkbox
              isLocalization={false}
              id={item[send]}
              name={item[send]}
              checked={
                this.state.selected.filter((x) => x[send] === item[send]).length
              }
              label={this.renderListOptionShow(item)}
              parentInputClassName="py-1"
              onChange={(event) => this.onChange(event, item)}
              theme={theme}
            />
          </div>
        );
      }
    });
  };
  renderOption = () => {
    let { isOpenOption, search } = this.state;
    let { show, hasChild, language, data, theme } = this.props;
    let searchData = [...data];
    if (data && hasChild)
      searchData = data.map((item) => {
        if (item.constructor === Array) return item[0];
        return getValue(item, hasChild);
      });
    if (isOpenOption) {
      if (search.length > 0) {
        searchData = data.filter((item) => {
          if (item?.[show]?.constructor === Array) {
            if (item?.[show]?.[0]?.[hasChild]?.[language?.name || 'en']) {
              return item?.[show]?.[0]?.[hasChild]?.[language?.name || 'en'];
            }
          } else if (item?.[show]?.[language?.name || 'en'])
            return (
              item?.[show]?.[language?.name || 'en']
                .toLowerCase()
                .indexOf(search.toLowerCase()) === 0
            );
        });
      }
      if (searchData && searchData.length > 0)
        return (
          <div
            className={`col px-0 d-flex flex-column border-top-0
             justify-content-start py-1 position-absolute 
            default-border-bottom-radius-small bg-white`}
            style={{
              color: '#999',
              zIndex: 3,
              border: '1px solid rgb(189, 198, 243)',
            }}
          >
            <div
              className="px-2"
              style={{
                maxHeight: '250px',
                overflowY: 'auto',
              }}
            >
              <div className=" d-flex py-1 align-items-center font-small justify-content-start cursor-pointer mt-2">
                <Checkbox
                  id="chkAll"
                  name="chkAll"
                  label="booking.selectall"
                  // disabled={true}
                  className="d-flex mx-2 px-0"
                  checked={this.state.selected.length === searchData.length}
                  theme={theme}
                  onChange={(event) => this.selectAll(event, searchData)}
                />
              </div>
              {this.renderListOption(searchData)}
            </div>
            <div className={`w-100 d-flex justify-content-center my-2  `}>
              <div className="d-flex col-6 px-2">
                <Button
                  name={`cancel-multiSelect`}
                  id={`cancel-multiSelect`}
                  className="bg-third"
                  onClick={() => {
                    this.setState(
                      {
                        isOpenOption: !this.state.isOpenOption,
                        search: '',
                        selected: [],
                      },
                      () =>
                        this.props.onClick({
                          stateName: this.props.id,
                          value: this.state.selected,
                        }),
                    );
                  }}
                  label={this.props.intl.formatMessage({
                    id: 'profile.cancel',
                  })}
                  themeMode={theme}
                />
              </div>
              <div className="d-flex justify-content-start col-6 px-2">
                <Button
                  name={`save-multiSelect`}
                  id={`save-multiSelect`}
                  onClick={this.onClickSelect}
                  label={this.props.intl.formatMessage({
                    id: 'commissionmanagement.save',
                  })}
                  themeMode={theme}
                />
              </div>
            </div>
          </div>
        );
    } else return null;
  };
  renderLabel = () => {
    let { selected } = this.state;
    let { label, language, show, topPosition } = this.props;

    if (selected) {
      return (
        <>
          <div
            className={'position-absolute text-success'}
            style={{
              top: topPosition ? topPosition : '-70%',
              width: '100%',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              fontSize: '0.7em',
            }}
          >
            {label}
          </div>
          <div
            className="text-start"
            style={{
              width: '100%',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {selected
              ? selected.map((x) => x?.[show]?.[language.name])?.join('-')
              : ''}
          </div>
        </>
      );
    } else return '';
  };
  renderSelectedLabelAndDefaultLabel = () => {
    return (
      <span
        className={`col-10 py-0 px-3 d-flex flex-start justify-content-start  ${this.props.className}`}
      >
        {this.renderLabel()}
      </span>
    );
  };
  renderSearchAndLabel = () => {
    let { isOpenOption, suggestion } = this.state;
    if (isOpenOption)
      return (
        <div
          className={
            'col p-0 d-flex justify-content-center align-items-center position-relative'
          }
        >
          <input
            type="text"
            autoFocus={true}
            placeholder={this.props.intl.formatMessage({
              id: 'dashboard.search',
            })}
            onChange={this.onChangeInput}
            className={
              'col px-3 rounded  outline-0 position-absolute bg-transparent border-0'
            }
            style={{
              color: '#999',
              fontSize: 'large',
            }}
          />
        </div>
      );
    else return this.renderSelectedLabelAndDefaultLabel();
  };
  onClickSelect = () => {
    const { id, onClick } = this.props;
    const { isOpenOption } = this.state;

    this.setState({ isOpenOption: !isOpenOption, search: '' }, () =>
      onClick({
        stateName: id,
        value: this.state.selected,
      }),
    );
  };
  handleclick = (e) => {
    if (this.node && this.node.contains(e.target)) {
      return;
    } else this.renderOption();
  };

  render = () => {
    let {
        className,
        isVisible = false,
        onClick = () => {},
        maxHeight = '75px',
        theme,
        classNameInput,
        ...rest
      } = this.props,
      { isOpenOption, selected } = this.state;
    return (
      <div
        className={`w-100  position-relative
        ${isVisible === true && 'dropdownDisabled'}`}
      >
        <div
          className={`bg-third-light  d-flex flex-column  cursor-pointer py-sm-2 py-1
          ${
            isOpenOption
              ? 'default-border-top-radius-small'
              : 'default-border-radius-small'
          }
          `}
          ref={(node) => {
            this.node = node;
          }}
          onClick={() => {
            this.onClickSelect();
          }}
          style={{ border: '1px solid rgb(189, 198, 243)' }}
        >
          <div
            className={`col d-flex p-0 flex-row justify-content-between align-items-center px-3 py-2 ${classNameInput}`}
          >
            {this.renderSearchAndLabel()}
            <div className={'text-center'}>
              {isOpenOption ? (
                <ChevronUpIcon color="#aaacaf" size={18} />
              ) : (
                <ChevronDownIcon color="#aaacaf" size={18} />
              )}
            </div>
          </div>
        </div>
        {this.renderOption()}
      </div>
    );
  };
}
MultiSelectDropDown.propTypes = {
  id: propTypes.string,
  language: propTypes.object,
  data: propTypes.array,
  send: propTypes.string,
  hasChild: propTypes.string,
  show: propTypes.string,
  name: propTypes.string,
  label: propTypes.string,
  topPosition: propTypes.string,
  className: propTypes.string,
  intl: propTypes.object,
  onClick: propTypes.func,
  theme: propTypes.string,
  value: propTypes.arrayOf(propTypes.object),
};
MultiSelectDropDown.defaultProps = {
  id: 'checkboxlist',
  language: {},
  data: [],
  send: 'id',
  hasChild: '',
  show: '',
  name: '',
  label: '',
  topPosition: '',
  className: undefined,
  classNameInput: '',
  theme: 'light',
  intl: {},
  value: [{}],
  onClick: () => {
    console.log('error');
  },
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(withRouter(MultiSelectDropDown)),
);
